import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Browser API-key controls are intentionally retired. This Vite client has no
 * authenticated Convex principal, and member projections must never expose an
 * API key merely to bootstrap management of other API keys.
 */
export function ApiKeyManagement() {
	return (
		<div className='container mx-auto p-6 pb-80'>
			<h1 className='text-3xl font-bold py-8'>API Key Management</h1>
			<Card className='glow-card'>
				<CardHeader>
					<CardTitle className='text-2xl text-pink-500'>
						Server-managed access
					</CardTitle>
				</CardHeader>
				<CardContent>
					<p className='text-muted-foreground'>
						API key management is unavailable in this browser session. Use an
						authenticated server-managed workflow; credentials are never exposed
						to the browser to authorize key listing, creation, or changes.
					</p>
				</CardContent>
			</Card>
		</div>
	);
}
